import { makeStyles } from '@material-ui/core';

export default makeStyles({
  root: {
    'transition': 'all 0.2s ease-in-out',

    '&.loader-transition-enter-done': {
      opacity: 1,
    },
    '&.loader-transition-enter': {
      opacity: 0,
    },
    '&.loader-transition-exit': {
      'transition-delay': '2.7s',
      'transition-timing-function': 'ease-out',
      'opacity': 0,
    },
  },
  Loader: {
    color: '#292929',
  },
  Loader__text: {
    position: 'absolute',
    right: 0,
    bottom: '-14px',
    fontSize: '10px',
  },
});
